import { AuthCard } from '../cards'
import { PasswordResetForm } from '../forms'

/**
 * Renders a panel for password reset.
 *
 * @author Maria Eduarda Franke
 * @returns {JSX.Element} The rendered PasswordResetPanel component.
 */
const PasswordResetPanel = () => {

    return (
        <AuthCard
            title="Redefinir senha"
            form={<PasswordResetForm />}
        />
    )
}

export default PasswordResetPanel